(function ($) {
    console.log('/search?view=ajax&q=test&type=product');

    let isOpen = false;
    let wasTransparent = false;
    let headerObserver = null;

    const $search = $('.Search');
    const $searchInput = $search.find('[name="q"]');
    const $overlay = $('.PageOverlay');
    const $header = $('.Header');

    let lastInputValue = '';

    const $input = $('#Search [name="q"]');
    const $results = $('#Search .Search__Results');
    
    function startHeaderObserver() {
        if (headerObserver) {
            return;
        }

        headerObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {

                if (
                    mutation.attributeName === 'class' &&
                    isOpen &&
                    $header.hasClass('Header--transparent')
                ) {
                    $header.removeClass('Header--transparent');
                }

            });
        });

        headerObserver.observe($header[0], {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function stopHeaderObserver() {
        if (headerObserver) {
            headerObserver.disconnect();
            headerObserver = null;
        }
    }

    function openSearch() {
        // Simpan kondisi awal header
        wasTransparent = $header.hasClass('Header--transparent');

        if (wasTransparent) {
            $header.removeClass('Header--transparent');
        }

        startHeaderObserver();

        $search.attr('aria-hidden', 'false');

        $('html').addClass('no-scroll');

        // focus input setelah animasi selesai
        $search.one('transitionend', function () {
            $searchInput.trigger('focus');
        });

        isOpen = true;

        $overlay.addClass('is-visible');

        $('#shopify-section-header').css('z-index', '10');
    }

    function closeSearch() {
        $search.attr('aria-hidden', 'true');

        $('html').removeClass('no-scroll');

        isOpen = false;

        stopHeaderObserver();

        if (wasTransparent) {
            $header.addClass('Header--transparent');
            wasTransparent = false;
        }

        $overlay.one('transitionend', function (e) {
            if (e.originalEvent.propertyName === 'visibility') {
                $('#shopify-section-header').css('z-index', '');
            }
        });

        $overlay.removeClass('is-visible');
    }

    function toggleSearch(e) {
        if (e) {
            e.preventDefault();
        }

        if (isOpen) {
            closeSearch();
        } else {
            openSearch();
        }
    }

    // Event binding
    $(document)
        .on('click', '[data-action="toggle-search"]', toggleSearch)
        .on('click', '[data-action="open-search"]', function (e) {
            e.preventDefault();
            openSearch();
        })
        .on('click', '[data-action="close-search"]', function (e) {
            e.preventDefault();
            closeSearch();
        })
        .on('search:close', function () {
            closeSearch();
        });

    let activeProductRequest = null;
    let activeJournalRequest = null;

    function resetSearch() {
        if (activeProductRequest) {
            activeProductRequest.abort();
            activeProductRequest = null;
        }
        if (activeJournalRequest) {
            activeJournalRequest.abort();
            activeJournalRequest = null;
        }
        $results
            .html(
                '<div class="PageLayout PageLayout--breakLap">' +
                    '<div class="PageLayout__Section"></div>' +
                    '<div class="PageLayout__Section PageLayout__Section--secondary"></div>' +
                '</div>'
            )
            .attr('aria-hidden', 'true');
    }

    function responseHtml(response) {
        return Array.isArray(response) ? response[0] : response;
    }

    function onInput(event) {

        lastInputValue = event.target.value;

        if (activeProductRequest) {
            activeProductRequest.abort();
        }
        if (activeJournalRequest) {
            activeJournalRequest.abort();
        }

        if (lastInputValue === '') {
            resetSearch();
            return;
        }

        const searchUrl = '/search?view=ajax&q=' + encodeURIComponent(lastInputValue) + '*';
        activeProductRequest = $.get(searchUrl + '&type=product');
        activeJournalRequest = $.get(searchUrl + '&type=article');

        $.when(activeProductRequest, activeJournalRequest).done(function (productResponse, journalResponse) {

            if (lastInputValue !== event.target.value) {
                return;
            }

            $results
                .html(
                    '<div class="PageLayout PageLayout--breakLap">' +
                        '<div class="PageLayout__Section">' + responseHtml(productResponse) + '</div>' +
                        '<div class="PageLayout__Section PageLayout__Section--secondary">' + responseHtml(journalResponse) + '</div>' +
                    '</div>'
                )
                .attr('aria-hidden', 'false');
        });
    }

    function debounce(fn, delay) {

        let timer;

        return function () {

            const context = this;
            const args = arguments;

            clearTimeout(timer);

            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    }

    $input.on('input', debounce(onInput, 250));

})(jQuery);